import React from "react";
import AdGroupMediaCard from "./AdGroupMediaCard";

const AdGroupUnitsCard = ({
  orgMedias,
  adgroupinfo,
  refetchAdGroupInfo,
  adGroupId,
}) => {
  return (
    <AdGroupMediaCard
      mediaType="DISPLAY"
      orgMedias={orgMedias}
      adgroupinfo={adgroupinfo}
      refetchAdGroupInfo={refetchAdGroupInfo}
      adGroupId={adGroupId}
    />
  );
};

export default AdGroupUnitsCard;